import React, { ReactNode } from "react";
import { RiCheckboxBlankCircleLine, RiRadioButtonLine } from "@remixicon/react";
import classNames from "classnames";
import { OnboardingProfile } from "../../../__generated__/api";
import Button from "../../../components/theme/button/Button";
import Styles from "../Onboarding.module.scss";

export interface StepProps {
    profile: OnboardingProfile;
    isV3: boolean;
    onNext: (profile: OnboardingProfile) => void;
    onDone: (profile: OnboardingProfile) => void;
    onReset: () => void;
    goBack: () => void;
    goNext: () => void;
    onSaveProfile: (profile: OnboardingProfile) => void
    stepId: string;
}

export function ChoiceButton({
    children,
    isSelected,
    onSelected,
    arrowDirection,
    metricPath,
}: {
    children: ReactNode;
    isSelected: boolean;
    onSelected: () => void;
    arrowDirection?: "left" | "right" | "up" | "down";
    metricPath: string[]
}) {
    const icon = isSelected ? <RiRadioButtonLine /> : <RiCheckboxBlankCircleLine />;

    return (
        <Button
            prefixIcon={icon}
            type="button"
            variant="outline-gray"
            metricPath={metricPath}
            className={classNames(
                Styles["choice-item"],
                isSelected ? Styles["choice-item-active"] : "",
                arrowDirection ? Styles[`choice-item-arrow-${arrowDirection}`] : "",
            )}
            onClick={onSelected}
        >
            {children}
        </Button>
    );
}

ChoiceButton.defaultProps = {
    arrowDirection: "",
};
